import React, { Component } from "react";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import { Accordion } from "semantic-ui-react";
import _ from "lodash";
import api from "../../api";
import {
  addItemToProgress,
  removeItemFromProgress,
} from "../../actions/progressList";
import BankruptciesDetails from "./BankruptciesDetails";
import LiensOrJudgmentsDetails from "./LiensOrJudgmentsDetails";

class BankruptciesLiensJudgmentsReportSection extends Component {
  constructor(props) {
    super(props);
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      activeIndex: 0,
      liensRecords: [],
      judgementsRecords: [],
      bankruptciesRecords: [],
      savedResultID,
      internalID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID &&
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadSection = (node, props) => {
    const liensRecords = _.get(
      node,
      "personReport.bljaddons[0].civilSearch[0].search_response[0].liens[0].record"
    );
    const judgementsRecords = _.get(
      node,
      "personReport.bljaddons[0].civilSearch[0].search_response[0].judgements[0].record"
    );
    const bankruptciesRecords = _.get(
      node,
      "personReport.bljaddons[0].civilSearch[0].search_response[0].bankruptcies[0].record"
    );
    this.setState({
      liensRecords,
      judgementsRecords,
      bankruptciesRecords,
    });
    const recLength =
      (liensRecords === undefined ? 0 : liensRecords.length) +
      (judgementsRecords === undefined ? 0 : judgementsRecords.length) +
      (bankruptciesRecords === undefined ? 0 : bankruptciesRecords.length);

    props.updateItemCountBySection(props.sectionName, recLength);
  };

  loadData = (props) => {
    const sectionNode = _.get(props.reportData, "personReport.bljaddons[0]");
    if (sectionNode) {
      this.loadSection(props.reportData, props);
    } else {
      const additionalData = _.cloneDeep(this.props.additionalData);
      additionalData.requestedSection = "bljaddon";
      api.report
        .person(additionalData, props.cancelToken)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            this.loadSection(rslt, props);
          });
        })
        .catch((err) => console.log("email res error - ", err));
    }
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled id={`nav_${this.props.sectionName}`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Rep_BLJ_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Bankruptcies, Liens and Judgments Involving Subject
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Rep_BLJ_Body`}
          active={this.state.activeIndex === 0}
        >
          <BankruptciesDetails
            {...this.props}
            records={this.state.bankruptciesRecords}
          />
          <LiensOrJudgmentsDetails
            {...this.props}
            records={this.state.liensRecords}
            title={"Liens"}
          />
          <LiensOrJudgmentsDetails
            {...this.props}
            records={this.state.judgementsRecords}
            title={"Judgments"}
          />
        </Accordion.Content>
      </Accordion>
    );
  }
}

function mapStateToProps(state) {
  return {
    cancelToken: state.apiCancelSource
      ? state.apiCancelSource.token
      : undefined,
  };
}

export default connect(mapStateToProps, {
  addItemToProgress,
  removeItemFromProgress,
})(BankruptciesLiensJudgmentsReportSection);



// WEBPACK FOOTER //
// ./src/components/reports/BankruptciesLiensJudgmentsReportSection.js